import { assertLoggableConnection } from 'hive-analytics-react';
function createAdministrator(name, email, redirectUri) {
    const connection = assertLoggableConnection();
    return connection.bee.api.invoke('carefinder_dev.inviteAdministrator', name, email, redirectUri);
}
export const AdministratorService = {
    createAdministrator,
};
